/** @format */

// eslint-disable-next-line no-use-before-define
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import store from './store'
import App from './App.tsx'
import './static/styles/common.styl'
import {localize} from '@king-design/react';
import i18n from '@king-design/react/i18n/en-US';
import Cookie from 'js-cookie'
import { getCurrentLang } from 'src/utils'
// import './public-path.js'

// 国际化相关
const lang = Cookie.get('ksc_lang')
const dict = getCurrentLang() || {}
const en = lang === 'en' ? i18n : {}
localize(Object.assign(dict, en))
document.domain = 'console.ksyun.com'

// 平台提供全局方法
const ksStorage = window.__ksStorage__
try {
  // 平台提供全局方法
  ksStorage &&
    ksStorage.getBaseInfo('userInfo', function (oData) {
      if (oData && oData.user) {
        const id = oData.user.id
        localStorage.userId = id
        localStorage.graphvisible = 1
      }
      console.timeEnd('_ksStorage_')
    })
  // 控制台接入文档自定义链接
  ksStorage &&
    ksStorage.docInit({
      indexUrl: '//docs.ksyun.com/products/2',
      // 英文地址（非必填，不传该参数时打开的是文档弹层首页）
      indexEnUrl: '//endocs.ksyun.com/products/2',
      // 设置文档的z-index，（非必填，不传该参数时默认是2000）
      zIndex: 10000
    })
} catch (error) {
  throw error
}
ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
)

function render(props) {
  const { container } = props
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    container ? container.querySelector('#root') : document.querySelector('#root')
  )
}

if (!window.__POWERED_BY_QIANKUN__) {
  render({})
}
/**
 * bootstrap 只会在微应用初始化的时候调用一次，下次微应用重新进入时会直接调用 mount 钩子，不会再重复触发 bootstrap。
 * 通常我们可以在这里做一些全局变量的初始化，比如不会在 unmount 阶段被销毁的应用级别的缓存等。
 */
export async function bootstrap() {
  console.log('react app bootstraped')
}

/**
 * 应用每次进入都会调用 mount 方法，通常我们在这里触发应用的渲染方法
 */
export async function mount(props) {
  console.log('props', props)
  render(props)
}

/**
 * 应用每次 切出/卸载 会调用的方法，通常在这里我们会卸载微应用的应用实例
 */
export async function unmount(props) {
  render(props)
  ReactDOM.unmountComponentAtNode(
    props.container ? props.container.querySelector('#root') : document.getElementById('root')
  )
}

/**
 * 可选生命周期钩子，仅使用 loadMicroApp 方式加载微应用时生效
 */
export async function update(props) {
  console.log('update props', props)
}
